import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TokenStore } from './token-store';

@Injectable({
    providedIn: 'root'
})
export class UserStorageService {

    /** Emits the token string whenever a user successfully logs in. */
    loggedIn$ = new Subject<string>();

    saveUser(data: any): void {
        if (!data) return;

        // POD1-8: the access token goes to memory, never to localStorage.
        // The refresh token is not handled here at all - the backend sets it
        // as an HttpOnly cookie this code cannot read, which is the point.
        if (data['access']) {
            TokenStore.set(data['access']);
        } else if (data['token']) {
            // Backend not yet deployed with JWT: fall back to the legacy key
            // so login keeps working. Still memory-only.
            TokenStore.set(data['token']);
        }

        const fields = [
            'is_superuser',
            'first_name',
            'last_name',
            'email',
            'avatar',
            'phoneNumber'
        ];

        fields.forEach(key => {
            if (data[key] !== undefined && data[key] !== null) {
                localStorage.setItem(key, data[key]);
            }
        });

        // Notify listeners (e.g. WebSocketService) that auth is now available
        // SCRUM-142: the JWT login response carries 'access', not the legacy
        // 'token', so listeners were never told a login had happened.
        const credential = data['access'] || data['token'];
        if (credential) {
            this.loggedIn$.next(credential);
        }
    }

    clearUser(): void {
        const keys = [
            'token',          // legacy - removed so old sessions stop lingering
            'is_superuser',
            'first_name',
            'last_name',
            'email',
            'avatar',
            'phoneNumber'
        ];

        keys.forEach(key => localStorage.removeItem(key));
        TokenStore.clear();
    }

    getUser(): any {
        return {
            token: TokenStore.get(),
            is_superuser: localStorage.getItem('is_superuser'),
            first_name: localStorage.getItem('first_name'),
            last_name: localStorage.getItem('last_name'),
            email: localStorage.getItem('email'),
            avatar: localStorage.getItem('avatar'),
            phoneNumber: localStorage.getItem('phoneNumber')
        };
    }
}
